<template>
    <div>
        <div class="case-spisi">
            <div class="spisi-left">
                <!-- Close case-folders-line -->
                <div class="opening-folder opening-radni-dokumenti section">
                    <div class="open-folder-line">
                        <div class="open-folder-line-left">
                            <div class="folder-tiny-icon">
                                <img src="@/assets/img/folder_yellow.svg" />
                            </div>
                            <draggable class="folder-open-name" :sort="false">
                                <span v-for="(bread, key) in breadCrumbs" @dragover="overFolder(bread.id, $event)"
                                    @dragleave="emptyDestDrag()" :key="key" @click="breadcrumbsViewPushback(bread.idx)"
                                    :class="[key == breadCrumbs.length - 1 ? 'active' : '', 'clickable-breadcrumb']">
                                    {{ getFolderName(bread.nazivFoldera)}} /</span>
                            </draggable>
                        </div>
                        <div class="open-folder-line-right" v-if="multi_file_list.length > 0">
                            <div class="novi-dokument-button icon-button radni-buttons" @click="select_all()"
                                v-if="!are_all_selected">
                                {{ $t('page_2.page_2_4.main_field.btn_4') }}
                                <svg class="odaberi-sve" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 5.41667C11.6667 3.22899 11.6902 2.5 14.5834 2.5C17.4767 2.5 17.5001 3.22899 17.5001 5.41667C17.5001 7.60434 17.5093 8.33333 14.5834 8.33333C11.6575 8.33333 11.6667 7.60434 11.6667 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 14.5834C2.5 12.3957 2.52342 11.6667 5.41667 11.6667C8.30991 11.6667 8.33333 12.3957 8.33333 14.5834C8.33333 16.7711 8.34256 17.5001 5.41667 17.5001C2.49077 17.5001 2.5 16.7711 2.5 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 14.5834C11.6667 12.3957 11.6902 11.6667 14.5834 11.6667C17.4767 11.6667 17.5001 12.3957 17.5001 14.5834C17.5001 16.7711 17.5093 17.5001 14.5834 17.5001C11.6575 17.5001 11.6667 16.7711 11.6667 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="novi-dokument-button icon-button radni-buttons"
                                @click="multi_file_list = []; activityFile = null;">
                                {{ $t('page_2.page_2_4.main_field.btn_1', { count: multi_file_list.length }) }}
                                <svg class="odaberi-sve" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 5.41667C11.6667 3.22899 11.6902 2.5 14.5834 2.5C17.4767 2.5 17.5001 3.22899 17.5001 5.41667C17.5001 7.60434 17.5093 8.33333 14.5834 8.33333C11.6575 8.33333 11.6667 7.60434 11.6667 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 14.5834C2.5 12.3957 2.52342 11.6667 5.41667 11.6667C8.30991 11.6667 8.33333 12.3957 8.33333 14.5834C8.33333 16.7711 8.34256 17.5001 5.41667 17.5001C2.49077 17.5001 2.5 16.7711 2.5 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 14.5834C11.6667 12.3957 11.6902 11.6667 14.5834 11.6667C17.4767 11.6667 17.5001 12.3957 17.5001 14.5834C17.5001 16.7711 17.5093 17.5001 14.5834 17.5001C11.6575 17.5001 11.6667 16.7711 11.6667 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div v-if="is_permission_inside('move') && (multi_file_list.length > 1 || (activityFile != null && activityFile.folder == undefined)) && movable"
                                class="novi-dokument-button icon-button radni-buttons radni-top-preseli"
                                @click="preseliStyling()">
                                {{ $t('page_2.page_2_4.main_field.btn_2') }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10"
                                    fill="none">
                                    <path
                                        d="M7.71967 1.28033C7.42678 0.987437 7.42678 0.512563 7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967L12.7803 4.21967C13.0732 4.51256 13.0732 4.98744 12.7803 5.28033L8.78033 9.28033C8.48744 9.57322 8.01256 9.57322 7.71967 9.28033C7.42678 8.98744 7.42678 8.51256 7.71967 8.21967L10.4393 5.5H0.75C0.335787 5.5 0 5.16421 0 4.75C0 4.33579 0.335787 4 0.75 4H10.4393L7.71967 1.28033Z"
                                        fill="#75747F" />
                                </svg>
                            </div>
                        </div>
                        <div class="open-folder-line-right" v-else>
                            <div class="novi-dokument-button icon-button radni-buttons" @click="select_all()"
                                v-if="!are_all_selected">
                                {{ $t('page_2.page_2_4.main_field.btn_4') }}
                                <svg class="odaberi-sve" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 5.41667C11.6667 3.22899 11.6902 2.5 14.5834 2.5C17.4767 2.5 17.5001 3.22899 17.5001 5.41667C17.5001 7.60434 17.5093 8.33333 14.5834 8.33333C11.6575 8.33333 11.6667 7.60434 11.6667 5.41667Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.5 14.5834C2.5 12.3957 2.52342 11.6667 5.41667 11.6667C8.30991 11.6667 8.33333 12.3957 8.33333 14.5834C8.33333 16.7711 8.34256 17.5001 5.41667 17.5001C2.49077 17.5001 2.5 16.7711 2.5 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.6667 14.5834C11.6667 12.3957 11.6902 11.6667 14.5834 11.6667C17.4767 11.6667 17.5001 12.3957 17.5001 14.5834C17.5001 16.7711 17.5093 17.5001 14.5834 17.5001C11.6575 17.5001 11.6667 16.7711 11.6667 14.5834Z"
                                        stroke="#7A7988" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="novi-folder-button icon-button radni-buttons"
                                v-if="is_permission_inside('create') && currDirectory.length > 0"
                                @click="newFolderPop = true">
                                {{ $t('page_2.page_2_4.main_field.btn_3') }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
                                    <g>
                                        <g>
                                            <path fill="#7b7b8a"
                                                d="M23.588 4.37v11.506c0 1.153-.928 2.09-2.08 2.102H2.094a2.102 2.102 0 0 1-2.08-2.102V2a2.102 2.102 0 0 1 2.08-2.105h7.703a.288.288 0 0 1 .231.104l1.907 2.269h9.573c1.152.011 2.08.95 2.08 2.102zm-7.465 5.665a.836.836 0 0 0-.835-.835h-2.652V6.547a.836.836 0 0 0-1.67 0V9.2H8.314a.836.836 0 0 0 0 1.67h2.652v2.653a.836.836 0 0 0 1.67 0V10.87h2.652c.46 0 .835-.374.835-.835z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div v-if="isInitialLoad || progressActive" class="center-spinner">
                        <svg class="dot-spin" viewBox="0 0 50 50">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                    <div class="inside-radni-dokumenti">
                        <draggable class="row" :sort="false">
                            <div v-if="!isInitialLoad && !progressActive && currDirectory.length == 0"
                                class="add-buttons-wrapper">
                                <div class="section-square kreiraj-spis" v-if="is_permission_inside('create')"
                                    @click="openUploadFolder">
                                    <svg class="wider" xmlns="http://www.w3.org/2000/svg" width="42" height="32"
                                        viewBox="0 0 42 32" fill="none">
                                        <path
                                            d="M33.2862 4.19414C33.3968 4.30546 33.4589 4.45603 33.4589 4.61297C33.4589 4.76991 33.3968 4.92048 33.2862 5.0318L21.2661 17.1247C20.8977 17.4965 20.4592 17.7915 19.976 17.9926C19.4928 18.1937 18.9744 18.2969 18.451 18.2962C17.9277 18.2968 17.4094 18.1936 16.9261 17.9925C16.4429 17.7914 16.0044 17.4964 15.636 17.1247L3.61674 5.03264C3.50585 4.92128 3.44359 4.77054 3.44359 4.61339C3.44359 4.45624 3.50585 4.30549 3.61674 4.19414C3.67122 4.13899 3.73611 4.09519 3.80765 4.06531C3.87919 4.03542 3.95594 4.02003 4.03347 4.02003C4.111 4.02003 4.18776 4.03542 4.2593 4.06531C4.33083 4.09519 4.39572 4.13899 4.45021 4.19414L16.4695 16.2862C16.7292 16.5474 17.038 16.7547 17.3782 16.8962C17.7183 17.0377 18.0831 17.1105 18.4515 17.1105C18.8199 17.1105 19.1846 17.0377 19.5248 16.8962C19.8649 16.7547 20.1737 16.5474 20.4335 16.2862L32.4536 4.19498C32.508 4.13995 32.5729 4.09626 32.6443 4.06645C32.7158 4.03664 32.7924 4.02129 32.8699 4.02129C32.9473 4.02129 33.024 4.03664 33.0954 4.06645C33.1669 4.09626 33.2317 4.13995 33.2862 4.19498V4.19414ZM1.17824 4.38996V22.9715C1.17824 24.7381 2.60753 26.1766 4.36402 26.1766H28.9029V27.3623H4.36402C1.95816 27.3623 0 25.3925 0 22.9715V4.38996C0 1.96904 1.95816 0 4.36402 0H32.5397C34.9456 0 36.9029 1.96987 36.9029 4.39079V19.2536H35.7255V4.39079C35.7255 2.62259 34.2962 1.18577 32.5397 1.18577H4.36402C2.60669 1.18577 1.17824 2.62343 1.17824 4.39079V4.38996ZM30.8268 26.6385C30.8268 26.2745 31.1197 25.9799 31.482 25.9799H35.5029V21.9347C35.5029 21.5715 35.7966 21.277 36.1582 21.277C36.5197 21.277 36.8126 21.5715 36.8126 21.9347V25.9799H40.8343C41.1958 25.9799 41.4887 26.2745 41.4887 26.6385C41.4887 27.0017 41.1958 27.2962 40.8343 27.2962H36.8134V31.3414C36.8134 31.7054 36.5205 32 36.159 32C36.0727 31.9998 35.9874 31.9826 35.9077 31.9494C35.8281 31.9161 35.7558 31.8676 35.695 31.8064C35.6341 31.7453 35.5859 31.6727 35.5531 31.5929C35.5203 31.5132 35.5035 31.4277 35.5038 31.3414V27.2971H31.4828C31.3088 27.2966 31.142 27.2271 31.0191 27.1038C30.8963 26.9805 30.8274 26.8134 30.8276 26.6393L30.8268 26.6385Z"
                                            fill="#B8B8C1" />
                                    </svg>
                                    <div>{{ $t('page_2.page_2_4.empty.btn_1') }}</div>
                                </div>
                                <div class="section-square kreiraj-spis" @click="templateStyling"
                                    v-if="is_permission_inside('template.create')">
                                    <svg class="wider" xmlns="http://www.w3.org/2000/svg" width="44" height="34"
                                        viewBox="0 0 44 34" fill="none">
                                        <path
                                            d="M32.782 23.4958C32.782 23.2239 33.0024 23.0035 33.2744 23.0035H37.8699C38.1418 23.0035 38.3623 23.2239 38.3623 23.4958C38.3623 23.7678 38.1418 23.9882 37.8699 23.9882H33.2744C33.0024 23.9882 32.782 23.7678 32.782 23.4958Z"
                                            fill="#B8B8C1" />
                                        <path
                                            d="M33.2744 24.973C33.0024 24.973 32.782 25.1934 32.782 25.4653C32.782 25.7373 33.0024 25.9577 33.2744 25.9577H36.5569C36.8288 25.9577 37.0493 25.7373 37.0493 25.4653C37.0493 25.1934 36.8288 24.973 36.5569 24.973H33.2744Z"
                                            fill="#B8B8C1" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M32.9461 20.3774C31.2239 20.3774 29.8277 21.7736 29.8277 23.4958V30.0609C29.8277 31.4205 30.93 32.5228 32.2896 32.5228H39.5112C40.1457 32.5228 40.66 32.0084 40.66 31.3739V21.5263C40.66 20.8918 40.1457 20.3774 39.5112 20.3774H32.9461ZM39.6753 27.599V21.5263C39.6753 21.4357 39.6018 21.3622 39.5112 21.3622H32.9461C31.7677 21.3622 30.8125 22.3175 30.8125 23.4958V28.0912C31.2239 27.7821 31.7354 27.599 32.2896 27.599H39.6753ZM39.6753 28.5837H32.2896C31.4738 28.5837 30.8125 29.2451 30.8125 30.0609C30.8125 30.8767 31.4738 31.538 32.2896 31.538H39.5112C39.6018 31.538 39.6753 31.4645 39.6753 31.3739V28.5837Z"
                                            fill="#B8B8C1" />
                                        <path
                                            d="M32.9858 4.15629C33.0954 4.2666 33.157 4.41581 33.157 4.57134C33.157 4.72687 33.0954 4.87608 32.9858 4.98639L21.0742 16.9701C20.7091 17.3386 20.2746 17.6309 19.7957 17.8302C19.3169 18.0295 18.8032 18.1318 18.2845 18.1311C17.7659 18.1317 17.2523 18.0294 16.7734 17.8301C16.2946 17.6308 15.86 17.3385 15.4949 16.9701L3.5841 4.98722C3.47421 4.87687 3.41251 4.72749 3.41251 4.57176C3.41251 4.41603 3.47421 4.26664 3.5841 4.15629C3.63809 4.10163 3.7024 4.05824 3.77329 4.02862C3.84418 3.999 3.92024 3.98375 3.99707 3.98375C4.0739 3.98375 4.14997 3.999 4.22086 4.02862C4.29175 4.05824 4.35606 4.10163 4.41005 4.15629L16.3208 16.1392C16.5782 16.3981 16.8843 16.6035 17.2213 16.7437C17.5584 16.8839 17.9199 16.9561 18.285 16.9561C18.65 16.9561 19.0115 16.8839 19.3486 16.7437C19.6856 16.6035 19.9917 16.3981 20.2491 16.1392L32.1607 4.15712C32.2147 4.10259 32.2789 4.0593 32.3497 4.02975C32.4205 4.00021 32.4965 3.985 32.5732 3.985C32.65 3.985 32.7259 4.00021 32.7968 4.02975C32.8676 4.0593 32.9318 4.10176 32.9858 4.15629ZM1.16761 4.35034V22.7642C1.16761 24.5148 2.584 25.9403 4.32463 25.9403H28.6421V27.1154H4.32463C1.94049 27.1154 0 25.1633 0 22.7642V4.35034C0 1.95127 1.94049 0 4.32463 0H32.2461C34.6302 0 36.5699 1.9521 36.5699 4.35117V19.0798H35.4031V4.35117C35.4031 2.59893 33.9867 1.17507 32.2461 1.17507H4.32463C2.58317 1.17507 1.16761 2.59893 1.16761 4.35034Z"
                                            fill="#B8B8C1" />
                                    </svg>
                                    <div>{{ $t('page_2.page_2_4.empty.btn_2') }}</div>
                                </div>
                                <div class="section-square kreiraj-spis" v-if="is_permission_inside('create')"
                                    @click="newFolderPop = true">
                                    <svg class="narrow" xmlns="http://www.w3.org/2000/svg" width="46" height="44"
                                        viewBox="0 0 46 44">
                                        <g>
                                            <g>
                                                <path fill="#b8b8c1"
                                                    d="M39.943 11.447v.191h.305a5.783 5.783 0 0 1 5.777 5.776v20.81A5.783 5.783 0 0 1 40.248 44H5.778A5.783 5.783 0 0 1 0 38.225V5.736A5.783 5.783 0 0 1 5.777-.039h11.127A5.792 5.792 0 0 1 21.17 1.84l3.378 3.694c.08.087.193.137.311.137h9.308a5.783 5.783 0 0 1 5.777 5.776zM10.442 38.225v-20.81a5.783 5.783 0 0 1 5.777-5.777h22.088v-.191a4.146 4.146 0 0 0-4.142-4.14h-9.308a2.065 2.065 0 0 1-1.518-.67l-3.377-3.694a4.153 4.153 0 0 0-3.058-1.347H5.777a4.146 4.146 0 0 0-4.142 4.14v32.489a4.146 4.146 0 0 0 4.142 4.14H6.3a4.146 4.146 0 0 0 4.143-4.14zm5.777-24.952a4.146 4.146 0 0 0-4.142 4.14v20.812a5.76 5.76 0 0 1-1.753 4.14h29.924a4.146 4.146 0 0 0 4.142-4.14V17.414a4.146 4.146 0 0 0-4.142-4.14zm5.356 14.547c0-.452.366-.818.817-.818h5.024v-5.02a.818.818 0 0 1 1.635 0v5.02h5.023a.817.817 0 1 1 0 1.635h-5.023v5.022a.817.817 0 1 1-1.635 0v-5.022h-5.024a.818.818 0 0 1-.817-.817z" />
                                            </g>
                                        </g>
                                    </svg>
                                    <div>{{ $t('page_2.page_2_4.empty.btn_3') }}</div>
                                </div>
                            </div>
                            <div v-for="selectedFile in currDirectory" :key="selectedFile.id">
                                <div class="radni-dokument-inside" v-if="selectedFile.folder != undefined"
                                    @dragover="overFolder(selectedFile.id, $event)" @dragleave="emptyDestDrag()"
                                    @dblclick="setNewFileView(selectedFile)"
                                    @click.left.exact="setFileForActivity(selectedFile)">
                                    <img src="@/assets/img/folder_yellow.svg" />
                                    <div>{{ selectedFile.name }}</div>
                                </div>
                                <div :id="selectedFile.name" class="radni-dokument-inside" v-else
                                    :draggable="is_permission_inside('move')" @dragstart="startDragMove(selectedFile)"
                                    @dragenter="emptyDestDrag()" @dblclick="handleFileOpen(selectedFile)"
                                    @click.left.exact="setFileForActivity(selectedFile)"
                                    @click.left.shift.exact="setMultiFileSelection(selectedFile)"
                                    @click.left.ctrl.exact="setMultiFileSelection(selectedFile)" @dragend="moveFile()">
                                    <img :src="returnFileType(selectedFile.name)" />
                                    <div>{{ selectedFile.name }}</div>
                                </div>
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
            <!-- Close spisi-left -->
            <div class="spisi-right" v-if="activityFile == null && view_name == 'spisi'">
                <div class="detalji-spisa section">
                    <div class="section-title">{{ $t('page_2.page_2_3.detail_1.title') }}
                        <div v-if="is_permission_inside('edit')" class="edit-detalji-spisa add-button add-pen"
                            @click="switchTab('spisi/' + selected_spis.id_spis + '/edit')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                <g>
                                    <g>
                                        <path fill="#7b7b8a"
                                            d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <!-- TODO dodati link na edit spisa -->
                    <div class="detalji-spisa-top">
                        <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
                        <div class="inside-folder-txts">
                            <div class="inside-folder-title">{{ selected_spis.ime }}</div>
                            <div class="detalji-spisa-tiny">
                                <span class="broj-dokumenata">{{ pdf_merge_file_list.length }}
                                    {{ $t('page_2.page_2_3.detail_1.sub_1') }}</span><span class="tezina"
                                    :key="pdf_merge_file_list.length">{{
                                            (all_files_rec.item.size * 0.000001).toFixed(4)
                                    }}
                                    MB</span>
                            </div>
                        </div>
                    </div>
                    <div class="detalji-spisa-list">
                        <div class="detalji-spisa-middle">
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_1') }}</div>
                                <div class="case-info-item-info">
                                    {{ switchDate(all_files_rec.item.createdDateTime) }}
                                </div>
                            </div>
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_2') }}:</div>
                                <div class="case-info-item-info">
                                    <a href="#">{{
                                            all_files_rec.item.createdBy.user.displayName
                                    }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="detalji-spisa-end">
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_3') }}:</div>
                                <div class="case-info-item-info">
                                    {{ selected_spis.opis_spisa }}
                                </div>
                            </div>
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_4') }}</div>
                                <div class="case-info-item-info">
                                    <router-link v-if="selected_spis.institucija != null"
                                        :to="'/osobe/institucije/' + selected_spis.institucija.uid">{{
                                                selected_spis.institucija.naziv
                                        }}
                                    </router-link>
                                </div>
                            </div>
                            <!-- Vidjeti kak bi izlgedalo s stvarnim vrijednostima -->
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_5') }}:</div>
                                <div class="case-info-item-info">
                                    <div class="info-item-element" v-for="(
                        sudionik, key
                      ) in selected_spis.spis_sudionici_connector" :key="key">
                                        <router-link :to="'/osobe/leg-body/' + sudionik.sluzbena_osoba.uid">{{
                                                sudionik.sluzbena_osoba.ime
                                        }}
                                            {{ sudionik.sluzbena_osoba.prezime }}</router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_6') }}:</div>
                                <div class="case-info-item-info">
                                    {{ selected_spis.posl_br }}
                                </div>
                            </div>
                            <div v-if="selected_spis.postupak.naziv != undefined && selected_spis.postupak.naziv != null"
                                class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_1.tl_7') }}:</div>
                                <div class="case-info-item-info">
                                    {{ selected_spis.postupak.naziv }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detalji-buttons" v-if="is_permission_inside('read')">
                        <div class="print-button icon-button" @click="spisToPDF()">
                            <svg v-if="!pdf_mergeing" xmlns="http://www.w3.org/2000/svg" width="20" height="18"
                                viewBox="0 0 20 18">
                                <g>
                                    <g>
                                        <path fill="#2b2b41"
                                            d="M16.206 3.132H3.97a.387.387 0 0 1-.387-.387V1.738c0-.94.763-1.704 1.704-1.704h9.602c.941 0 1.704.763 1.704 1.704v1.007a.387.387 0 0 1-.387.387zM20 6.462v7.279c0 1.153-.938 2.09-2.09 2.09h-1.317v-3.097a2.79 2.79 0 0 0-2.788-2.788H6.371a2.79 2.79 0 0 0-2.788 2.788v3.098H2.267A2.093 2.093 0 0 1 .176 13.74v-7.28c0-1.152.938-2.09 2.09-2.09H17.91c1.153 0 2.091.938 2.091 2.09zM4.823 8.088a.93.93 0 1 0-1.86 0 .93.93 0 0 0 1.86 0zm9.911 4.646v4.337a.93.93 0 0 1-.929.929H6.371a.93.93 0 0 1-.93-.93v-4.336a.93.93 0 0 1 .93-.929h7.434a.93.93 0 0 1 .93.93z" />
                                    </g>
                                </g>
                            </svg>
                            <span v-if="!pdf_mergeing">{{ $t('page_2.page_2_3.detail_1.btn_1') }}</span>

                            <div v-if="pdf_mergeing" class="elastic-wrapp">
                                <div class="dot-elastic"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spisi-right" v-if="activityFile != null">
                <div class="detalji-spisa section detalji-radni-popratna">
                    <div class="section-title">
                        <span>{{ $t('page_2.page_2_4.detail_2.title') }}</span>
                        <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('rename')"
                            @click="activityFile.folder == undefined ? openRenamePop() : openFolderRenamePop()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                <g>
                                    <g>
                                        <path fill="#7b7b8a"
                                            d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="edit-detalji-spisa add-button add-pen folder-eye"
                            v-if="activityFile.folder == undefined" @click="setStyling()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9"
                                fill="none">
                                <path
                                    d="M13.8906 3.84153C13.9617 3.93705 14 4.05292 14 4.17195C14 4.29097 13.9617 4.40684 13.8906 4.50236C12.101 6.87818 9.67519 8.34154 7.00011 8.34154C4.32503 8.34154 1.89982 6.87818 0.10958 4.50001C0.0384287 4.40443 0 4.28845 0 4.1693C0 4.05015 0.0384287 3.93417 0.10958 3.83859C1.89982 1.46336 4.32503 0 7.00011 0C9.67519 0 12.101 1.46277 13.8906 3.84153ZM9.93858 4.36243C9.96545 3.94454 9.9029 3.52572 9.75511 3.13391C9.60732 2.7421 9.37769 2.38631 9.08153 2.09026C8.78537 1.79421 8.42949 1.56471 8.03762 1.41707C7.64576 1.26943 7.22692 1.20704 6.80903 1.23406C5.34274 1.32519 4.15394 2.5134 4.06282 3.9791C4.03603 4.397 4.09865 4.81581 4.24651 5.20759C4.39437 5.59938 4.62407 5.95513 4.92029 6.25112C5.21651 6.54712 5.57243 6.77655 5.96432 6.92411C6.35622 7.07168 6.77507 7.13399 7.19295 7.10689C8.65631 7.01282 9.84451 5.8252 9.93917 4.36243H9.93858ZM7.10358 5.75053C6.87866 5.7655 6.65314 5.73225 6.44211 5.65301C6.23108 5.57377 6.03941 5.45036 5.87993 5.29105C5.72046 5.13174 5.59685 4.9402 5.51739 4.72925C5.43792 4.51831 5.40444 4.29282 5.41917 4.06788C5.4453 3.68376 5.60974 3.32213 5.88204 3.04994C6.15433 2.77776 6.51603 2.61346 6.90016 2.58748C7.12509 2.57259 7.3506 2.60592 7.5616 2.68523C7.7726 2.76455 7.96423 2.88802 8.12365 3.04739C8.28307 3.20675 8.40661 3.39834 8.486 3.60931C8.56539 3.82029 8.5988 4.04579 8.58399 4.27072C8.55773 4.65464 8.39332 5.01605 8.12116 5.28811C7.849 5.56016 7.48751 5.72443 7.10358 5.75053Z"
                                    fill="#70707F" />
                            </svg>
                        </div>
                    </div>
                    <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
                    <div class="detalji-spisa-top">
                        <img class="doc-icon"
                            :src="activityFile.folder != undefined ? returnFileType('a.folder') : returnFileType(activityFile.name)" />
                        <div class="inside-folder-txts">
                            <div class="inside-folder-title">{{ activityFile.name }}</div>
                            <div class="detalji-spisa-tiny">
                                <span class="tezina">{{ (activityFile.size * 0.000001).toFixed(4) }}MB</span>
                            </div>
                        </div>
                    </div>
                    <div class="detalji-spisa-list">
                        <div class="detalji-spisa-middle">
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_4.detail_2.tl_1') }}</div>
                                <div class="case-info-item-info">
                                    {{ switchDate(activityFile.createdDateTime) }}
                                </div>
                            </div>
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_4.detail_2.tl_2') }}:</div>
                                <div class="case-info-item-info">
                                    <a href="#">{{ activityFile.createdBy.user.displayName }}</a>
                                </div>
                            </div>
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t('page_2.page_2_4.detail_2.tl_3') }}:</div>
                                <div class="case-info-item-info">
                                    <a href="#">{{ activityFile.lastModifiedBy.user.displayName }} ({{
                                            switchDate(activityFile.lastModifiedDateTime)
                                    }})</a>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="detalji-buttons detalji-buttons-tri">
                        <div class="radni-button icon-button"
                            v-if="is_permission_inside('move') && activityFile.folder == undefined && movable"
                            @click="preseliStyling()">
                            {{ $t('page_2.page_2_4.detail_2.btn_1') }}
                            <svg class="preseli-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="10"
                                viewBox="0 0 13 10" fill="none">
                                <path
                                    d="M7.71967 1.28033C7.42678 0.987437 7.42678 0.512563 7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967L12.7803 4.21967C13.0732 4.51256 13.0732 4.98744 12.7803 5.28033L8.78033 9.28033C8.48744 9.57322 8.01256 9.57322 7.71967 9.28033C7.42678 8.98744 7.42678 8.51256 7.71967 8.21967L10.4393 5.5H0.75C0.335787 5.5 0 5.16421 0 4.75C0 4.33579 0.335787 4 0.75 4H10.4393L7.71967 1.28033Z"
                                    fill="#75747F" />
                            </svg>
                        </div>
                        <div class="radni-button icon-button"
                            v-if="is_permission_inside('read') && activityFile.folder == undefined"
                            @click="handleFileOpen(activityFile)">
                            {{ $t('page_2.page_2_4.detail_2.btn_2') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M6.61764 8.31605C6.61764 6.06224 8.44471 4.23516 10.6985 4.23516C12.9523 4.23516 14.7794 6.06224 14.7794 8.31605C14.7794 10.5699 12.9523 12.3969 10.6985 12.3969C8.44471 12.3969 6.61764 10.5699 6.61764 8.31605ZM10.6985 5.86752C9.34623 5.86752 8.24999 6.96376 8.24999 8.31605C8.24999 9.66833 9.34623 10.7646 10.6985 10.7646C12.0508 10.7646 13.147 9.66833 13.147 8.31605C13.147 6.96376 12.0508 5.86752 10.6985 5.86752Z"
                                    fill="#70707F" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2.3446 6.84296C1.8885 7.50018 1.72058 8.01428 1.72058 8.31605C1.72058 8.61782 1.8885 9.13191 2.3446 9.78913C2.78549 10.4244 3.44083 11.1131 4.26996 11.7495C5.93181 13.0249 8.21022 14.0293 10.6985 14.0293C13.1868 14.0293 15.4652 13.0249 17.1271 11.7495C17.9562 11.1131 18.6115 10.4244 19.0524 9.78913C19.5085 9.13191 19.6765 8.61782 19.6765 8.31605C19.6765 8.01428 19.5085 7.50018 19.0524 6.84296C18.6115 6.20765 17.9562 5.51898 17.1271 4.88263C15.4652 3.60717 13.1868 2.60281 10.6985 2.60281C8.21022 2.60281 5.93181 3.60717 4.26996 4.88263C3.44083 5.51898 2.78549 6.20765 2.3446 6.84296ZM3.27611 3.5877C5.15903 2.14257 7.77768 0.970459 10.6985 0.970459C13.6194 0.970459 16.238 2.14257 18.1209 3.5877C19.0642 4.31165 19.8432 5.1193 20.3935 5.91229C20.9286 6.68338 21.3088 7.52958 21.3088 8.31605C21.3088 9.10251 20.9286 9.94871 20.3935 10.7198C19.8432 11.5128 19.0642 12.3204 18.1209 13.0444C16.238 14.4895 13.6194 15.6616 10.6985 15.6616C7.77768 15.6616 5.15903 14.4895 3.27611 13.0444C2.33285 12.3204 1.55387 11.5128 1.00354 10.7198C0.468424 9.94871 0.0882263 9.10251 0.0882263 8.31605C0.0882263 7.52958 0.468424 6.68338 1.00354 5.91229C1.55387 5.1193 2.33285 4.31165 3.27611 3.5877Z"
                                    fill="#70707F" />
                            </svg>
                        </div>
                        <v-tooltip top v-if="duplicatable">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                                    <div class="delete-button icon-button duplicate-button"
                                        v-if="activityFile != null && activityFile.folder == undefined"
                                        @click="copyFile">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                            viewBox="0 0 18 18" fill="none">
                                            <path
                                                d="M5.75 0C2.57436 0 0 2.57436 0 5.75V12.8569C0 13.2711 0.335786 13.6069 0.75 13.6069C1.16421 13.6069 1.5 13.2711 1.5 12.8569V5.75C1.5 3.40279 3.40279 1.5 5.75 1.5H12.7629C13.1771 1.5 13.5129 1.16421 13.5129 0.75C13.5129 0.335786 13.1771 0 12.7629 0H5.75Z"
                                                fill="#70707F" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M15.1526 3.54326C11.9116 3.18104 8.58843 3.18104 5.34748 3.54326C4.4242 3.64645 3.68227 4.37304 3.57344 5.30348C3.18906 8.58996 3.18906 11.91 3.57344 15.1965C3.68227 16.127 4.4242 16.8535 5.34748 16.9567C8.58843 17.319 11.9116 17.319 15.1526 16.9567C16.0758 16.8535 16.8178 16.127 16.9266 15.1965C17.311 11.91 17.311 8.58996 16.9266 5.30348C16.8178 4.37304 16.0758 3.64645 15.1526 3.54326ZM5.51409 5.03398C8.64431 4.68413 11.8557 4.68413 14.9859 5.03398C15.2233 5.0605 15.4099 5.24821 15.4367 5.47773C15.8076 8.64843 15.8076 11.8516 15.4367 15.0223C15.4099 15.2518 15.2233 15.4395 14.9859 15.466C11.8557 15.8159 8.64431 15.8159 5.51409 15.466C5.27674 15.4395 5.09013 15.2518 5.06329 15.0223C4.69245 11.8516 4.69245 8.64844 5.06329 5.47773C5.09013 5.24821 5.27674 5.0605 5.51409 5.03398Z"
                                                fill="#70707F" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <div>
                                {{ $t('page_2.page_2_4.detail_2.btn_3') }}
                            </div>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                                    <div class="delete-button icon-button"
                                        v-if="is_permission_inside('delete') && activityFile != null && activityFile.folder == undefined"
                                        @click="delete_screen = true">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                                            viewBox="0 0 16 21" fill="none">
                                            <path
                                                d="M5.75 0C5.33579 0 5 0.335786 5 0.75V1.5H0.75C0.335786 1.5 0 1.83579 0 2.25C0 2.66421 0.335786 3 0.75 3H14.75C15.1642 3 15.5 2.66421 15.5 2.25C15.5 1.83579 15.1642 1.5 14.75 1.5H10.5V0.75C10.5 0.335786 10.1642 0 9.75 0H5.75Z"
                                                fill="#70707F" />
                                            <path
                                                d="M5.75 8.39999C6.16421 8.39999 6.5 8.73578 6.5 9.14999L6.5 16.15C6.5 16.5642 6.16421 16.9 5.75 16.9C5.33579 16.9 5 16.5642 5 16.15L5 9.14999C5 8.73578 5.33579 8.39999 5.75 8.39999Z"
                                                fill="#70707F" />
                                            <path
                                                d="M10.5 9.14999C10.5 8.73578 10.1642 8.39999 9.75 8.39999C9.33579 8.39999 9 8.73578 9 9.14999V16.15C9 16.5642 9.33579 16.9 9.75 16.9C10.1642 16.9 10.5 16.5642 10.5 16.15V9.14999Z"
                                                fill="#70707F" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M1.74142 5.66718C1.78363 5.28735 2.10468 5 2.48684 5H13.0132C13.3953 5 13.7164 5.28735 13.7586 5.66718L13.9587 7.46852C14.3215 10.7338 14.3215 14.0293 13.9587 17.2946L13.939 17.472C13.795 18.7681 12.7904 19.8017 11.4989 19.9825C9.01176 20.3307 6.48823 20.3307 4.00108 19.9825C2.70954 19.8017 1.705 18.7681 1.56098 17.472L1.54128 17.2946C1.17846 14.0293 1.17846 10.7338 1.54128 7.46852L1.74142 5.66718ZM3.15812 6.5L3.0321 7.63417C2.68152 10.7894 2.68152 13.9738 3.0321 17.129L3.0518 17.3063C3.12011 17.921 3.59652 18.4112 4.20905 18.497C6.55822 18.8258 8.94177 18.8258 11.2909 18.497C11.9035 18.4112 12.3799 17.921 12.4482 17.3063L12.4679 17.129C12.8185 13.9738 12.8185 10.7894 12.4679 7.63417L12.3419 6.5H3.15812Z"
                                                fill="#70707F" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <div>
                                {{ $t('page_2.page_2_4.detail_2.btn_4') }}
                            </div>
                        </v-tooltip>
                        <div class="delete-button icon-button"
                            v-if="is_permission_inside('delete') && activityFile != null && activityFile.id != folder_id && activityFile.folder != undefined"
                            @click="delete_screen = true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                                <g>
                                    <g>
                                        <path fill="#2b2b41"
                                            d="M12.8 5.63v9.455C12.8 16.692 11.5 18 9.904 18H3.52C1.925 18 .626 16.692.626 15.085V5.63c0-.334.27-.605.601-.605h10.971c.332 0 .601.27.601.605zM5.267 8.67c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm4.367 0c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm3.78-5.896V3.95c0 .21-.17.38-.378.38H.389a.379.379 0 0 1-.378-.38V2.774c0-1.01.816-1.83 1.819-1.83h2.618v-.23c0-.393.318-.712.708-.712H8.27c.391 0 .709.32.709.713v.228h2.618c1.003 0 1.819.822 1.819 1.831z" />
                                    </g>
                                </g>
                            </svg>
                            {{ $t('page_2.page_2_4.detail_2.btn_4') }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="activityFile == null && view_name != 'spisi'" class="spisi-right">
                <div class="detalji-spisa section detalji-radni-popratna">
                    <div class="section-title"> {{ $t('page_2.page_2_4.detail_1.title') }}</div>
                    <div class="detalji-radni-upute-wrapper">
                        <div class="inside-folder-uputa">
                            <svg style="margin:1rem 0;" xmlns="http://www.w3.org/2000/svg" width="136" height="26"
                                viewBox="0 0 136 26" fill="none">
                                <rect width="55" height="26" rx="5" fill="#ECECEC" />
                                <path
                                    d="M19.99 17.08C19.47 17.08 19.0167 16.9967 18.63 16.83C18.2433 16.6633 17.9433 16.43 17.73 16.13C17.5233 15.83 17.42 15.4767 17.42 15.07V14.82C17.42 14.7867 17.43 14.76 17.45 14.74C17.4767 14.7133 17.5067 14.7 17.54 14.7H18.43C18.4633 14.7 18.49 14.7133 18.51 14.74C18.5367 14.76 18.55 14.7867 18.55 14.82V15.01C18.55 15.3167 18.6867 15.5733 18.96 15.78C19.2333 15.98 19.6067 16.08 20.08 16.08C20.4867 16.08 20.7933 15.9933 21 15.82C21.2067 15.6467 21.31 15.4233 21.31 15.15C21.31 14.9633 21.2533 14.8067 21.14 14.68C21.0267 14.5467 20.8633 14.4267 20.65 14.32C20.4433 14.2133 20.13 14.08 19.71 13.92C19.2367 13.7467 18.8533 13.5833 18.56 13.43C18.2667 13.2767 18.02 13.07 17.82 12.81C17.6267 12.5433 17.53 12.2133 17.53 11.82C17.53 11.2333 17.7433 10.77 18.17 10.43C18.5967 10.09 19.1667 9.92 19.88 9.92C20.38 9.92 20.82 10.0067 21.2 10.18C21.5867 10.3533 21.8867 10.5967 22.1 10.91C22.3133 11.2167 22.42 11.5733 22.42 11.98V12.15C22.42 12.1833 22.4067 12.2133 22.38 12.24C22.36 12.26 22.3333 12.27 22.3 12.27H21.4C21.3667 12.27 21.3367 12.26 21.31 12.24C21.29 12.2133 21.28 12.1833 21.28 12.15V12.04C21.28 11.7267 21.15 11.4633 20.89 11.25C20.6367 11.03 20.2833 10.92 19.83 10.92C19.4633 10.92 19.1767 10.9967 18.97 11.15C18.77 11.3033 18.67 11.52 18.67 11.8C18.67 12 18.7233 12.1633 18.83 12.29C18.9367 12.4167 19.0967 12.5333 19.31 12.64C19.5233 12.74 19.8533 12.87 20.3 13.03C20.7733 13.21 21.15 13.3733 21.43 13.52C21.7167 13.6667 21.96 13.8733 22.16 14.14C22.3667 14.4 22.47 14.7267 22.47 15.12C22.47 15.72 22.2467 16.1967 21.8 16.55C21.36 16.9033 20.7567 17.08 19.99 17.08ZM25.9782 11.81C26.5182 11.81 26.9482 11.97 27.2682 12.29C27.5949 12.61 27.7582 13.0467 27.7582 13.6V16.88C27.7582 16.9133 27.7449 16.9433 27.7182 16.97C27.6982 16.99 27.6715 17 27.6382 17H26.7182C26.6849 17 26.6549 16.99 26.6282 16.97C26.6082 16.9433 26.5982 16.9133 26.5982 16.88V13.84C26.5982 13.5333 26.5115 13.2867 26.3382 13.1C26.1649 12.9067 25.9349 12.81 25.6482 12.81C25.3615 12.81 25.1282 12.9033 24.9482 13.09C24.7749 13.2767 24.6882 13.5233 24.6882 13.83V16.88C24.6882 16.9133 24.6749 16.9433 24.6482 16.97C24.6282 16.99 24.6015 17 24.5682 17H23.6482C23.6149 17 23.5849 16.99 23.5582 16.97C23.5382 16.9433 23.5282 16.9133 23.5282 16.88V10.12C23.5282 10.0867 23.5382 10.06 23.5582 10.04C23.5849 10.0133 23.6149 10 23.6482 10H24.5682C24.6015 10 24.6282 10.0133 24.6482 10.04C24.6749 10.06 24.6882 10.0867 24.6882 10.12V12.33C24.6882 12.35 24.6949 12.3633 24.7082 12.37C24.7215 12.3767 24.7315 12.37 24.7382 12.35C25.0115 11.99 25.4249 11.81 25.9782 11.81ZM29.6277 11.19C29.421 11.19 29.251 11.1233 29.1177 10.99C28.9843 10.8567 28.9177 10.6867 28.9177 10.48C28.9177 10.2733 28.9843 10.1033 29.1177 9.97C29.251 9.83667 29.421 9.77 29.6277 9.77C29.8343 9.77 30.0043 9.83667 30.1377 9.97C30.271 10.1033 30.3377 10.2733 30.3377 10.48C30.3377 10.6867 30.271 10.8567 30.1377 10.99C30.0043 11.1233 29.8343 11.19 29.6277 11.19ZM29.1477 17C29.1143 17 29.0843 16.99 29.0577 16.97C29.0377 16.9433 29.0277 16.9133 29.0277 16.88V12C29.0277 11.9667 29.0377 11.94 29.0577 11.92C29.0843 11.8933 29.1143 11.88 29.1477 11.88H30.0677C30.101 11.88 30.1277 11.8933 30.1477 11.92C30.1743 11.94 30.1877 11.9667 30.1877 12V16.88C30.1877 16.9133 30.1743 16.9433 30.1477 16.97C30.1277 16.99 30.101 17 30.0677 17H29.1477ZM34.1765 11.88C34.2098 11.88 34.2365 11.8933 34.2565 11.92C34.2832 11.94 34.2965 11.9667 34.2965 12V12.79C34.2965 12.8233 34.2832 12.8533 34.2565 12.88C34.2365 12.9 34.2098 12.91 34.1765 12.91H33.1865C33.1532 12.91 33.1365 12.9267 33.1365 12.96V16.88C33.1365 16.9133 33.1232 16.9433 33.0965 16.97C33.0765 16.99 33.0498 17 33.0165 17H32.0965C32.0632 17 32.0332 16.99 32.0065 16.97C31.9865 16.9433 31.9765 16.9133 31.9765 16.88V12.96C31.9765 12.9267 31.9598 12.91 31.9265 12.91H31.3065C31.2732 12.91 31.2432 12.9 31.2165 12.88C31.1965 12.8533 31.1865 12.8233 31.1865 12.79V12C31.1865 11.9667 31.1965 11.94 31.2165 11.92C31.2432 11.8933 31.2732 11.88 31.3065 11.88H31.9265C31.9598 11.88 31.9765 11.8633 31.9765 11.83V11.65C31.9765 11.2167 32.0332 10.8833 32.1465 10.65C32.2598 10.41 32.4465 10.24 32.7065 10.14C32.9665 10.04 33.3332 9.99333 33.8065 10H34.1565C34.1898 10 34.2165 10.0133 34.2365 10.04C34.2632 10.06 34.2765 10.0867 34.2765 10.12V10.82C34.2765 10.8533 34.2632 10.8833 34.2365 10.91C34.2165 10.93 34.1898 10.94 34.1565 10.94H33.8965C33.6098 10.94 33.4098 10.9967 33.2965 11.11C33.1898 11.2233 33.1365 11.43 33.1365 11.73V11.83C33.1365 11.8633 33.1532 11.88 33.1865 11.88H34.1765ZM37.9863 12.71C37.9863 12.7433 37.9729 12.7733 37.9463 12.8C37.9263 12.82 37.8996 12.83 37.8663 12.83H36.8463C36.8129 12.83 36.7963 12.8467 36.7963 12.88V15.29C36.7963 15.5433 36.8496 15.7267 36.9563 15.84C37.0696 15.9533 37.2463 16.01 37.4863 16.01H37.7863C37.8196 16.01 37.8463 16.0233 37.8663 16.05C37.8929 16.07 37.9063 16.0967 37.9063 16.13V16.88C37.9063 16.9533 37.8663 16.9967 37.7863 17.01L37.2663 17.02C36.7396 17.02 36.3463 16.93 36.0863 16.75C35.8263 16.57 35.6929 16.23 35.6863 15.73V12.88C35.6863 12.8467 35.6696 12.83 35.6363 12.83H35.0663C35.0329 12.83 35.0029 12.82 34.9763 12.8C34.9563 12.7733 34.9463 12.7433 34.9463 12.71V12.01C34.9463 11.9767 34.9563 11.95 34.9763 11.93C35.0029 11.9033 35.0329 11.89 35.0663 11.89H35.6363C35.6696 11.89 35.6863 11.8733 35.6863 11.84V10.67C35.6863 10.6367 35.6963 10.61 35.7163 10.59C35.7429 10.5633 35.7729 10.55 35.8063 10.55H36.6763C36.7096 10.55 36.7363 10.5633 36.7563 10.59C36.7829 10.61 36.7963 10.6367 36.7963 10.67V11.84C36.7963 11.8733 36.8129 11.89 36.8463 11.89H37.8663C37.8996 11.89 37.9263 11.9033 37.9463 11.93C37.9729 11.95 37.9863 11.9767 37.9863 12.01V12.71Z"
                                    fill="#70707F" />
                                <rect x="81" width="55" height="26" rx="5" fill="#ECECEC" />
                                <path
                                    d="M104.07 17.08C103.57 17.08 103.13 16.9833 102.75 16.79C102.37 16.59 102.077 16.3133 101.87 15.96C101.663 15.6067 101.56 15.1967 101.56 14.73V12.26C101.56 11.7933 101.663 11.3833 101.87 11.03C102.077 10.6767 102.37 10.4033 102.75 10.21C103.13 10.0167 103.57 9.92 104.07 9.92C104.563 9.92 105 10.0133 105.38 10.2C105.76 10.3867 106.053 10.65 106.26 10.99C106.467 11.33 106.57 11.7233 106.57 12.17C106.57 12.2033 106.557 12.2333 106.53 12.26C106.51 12.28 106.483 12.29 106.45 12.29L105.53 12.34C105.45 12.34 105.41 12.3033 105.41 12.23C105.41 11.8367 105.287 11.52 105.04 11.28C104.8 11.04 104.477 10.92 104.07 10.92C103.663 10.92 103.337 11.04 103.09 11.28C102.843 11.52 102.72 11.8367 102.72 12.23V14.78C102.72 15.1667 102.843 15.48 103.09 15.72C103.337 15.96 103.663 16.08 104.07 16.08C104.477 16.08 104.8 15.9633 105.04 15.73C105.287 15.49 105.41 15.1733 105.41 14.78C105.41 14.7067 105.45 14.67 105.53 14.67L106.45 14.71C106.483 14.71 106.51 14.72 106.53 14.74C106.557 14.76 106.57 14.7833 106.57 14.81C106.57 15.2633 106.467 15.6633 106.26 16.01C106.053 16.35 105.76 16.6133 105.38 16.8C105 16.9867 104.563 17.08 104.07 17.08ZM110.414 12.71C110.414 12.7433 110.401 12.7733 110.374 12.8C110.354 12.82 110.327 12.83 110.294 12.83H109.274C109.241 12.83 109.224 12.8467 109.224 12.88V15.29C109.224 15.5433 109.277 15.7267 109.384 15.84C109.497 15.9533 109.674 16.01 109.914 16.01H110.214C110.247 16.01 110.274 16.0233 110.294 16.05C110.321 16.07 110.334 16.0967 110.334 16.13V16.88C110.334 16.9533 110.294 16.9967 110.214 17.01L109.694 17.02C109.167 17.02 108.774 16.93 108.514 16.75C108.254 16.57 108.121 16.23 108.114 15.73V12.88C108.114 12.8467 108.097 12.83 108.064 12.83H107.494C107.461 12.83 107.431 12.82 107.404 12.8C107.384 12.7733 107.374 12.7433 107.374 12.71V12.01C107.374 11.9767 107.384 11.95 107.404 11.93C107.431 11.9033 107.461 11.89 107.494 11.89H108.064C108.097 11.89 108.114 11.8733 108.114 11.84V10.67C108.114 10.6367 108.124 10.61 108.144 10.59C108.171 10.5633 108.201 10.55 108.234 10.55H109.104C109.137 10.55 109.164 10.5633 109.184 10.59C109.211 10.61 109.224 10.6367 109.224 10.67V11.84C109.224 11.8733 109.241 11.89 109.274 11.89H110.294C110.327 11.89 110.354 11.9033 110.374 11.93C110.401 11.95 110.414 11.9767 110.414 12.01V12.71ZM113.824 11.83C114.038 11.83 114.224 11.8733 114.384 11.96C114.438 11.9867 114.458 12.0367 114.444 12.11L114.274 13.01C114.268 13.09 114.221 13.1133 114.134 13.08C114.034 13.0467 113.918 13.03 113.784 13.03C113.698 13.03 113.631 13.0333 113.584 13.04C113.304 13.0533 113.071 13.1533 112.884 13.34C112.698 13.52 112.604 13.7567 112.604 14.05V16.88C112.604 16.9133 112.591 16.9433 112.564 16.97C112.544 16.99 112.518 17 112.484 17H111.564C111.531 17 111.501 16.99 111.474 16.97C111.454 16.9433 111.444 16.9133 111.444 16.88V12.01C111.444 11.9767 111.454 11.95 111.474 11.93C111.501 11.9033 111.531 11.89 111.564 11.89H112.484C112.518 11.89 112.544 11.9033 112.564 11.93C112.591 11.95 112.604 11.9767 112.604 12.01V12.46C112.604 12.4867 112.608 12.5033 112.614 12.51C112.628 12.51 112.641 12.5 112.654 12.48C112.934 12.0467 113.324 11.83 113.824 11.83ZM115.324 17C115.291 17 115.261 16.99 115.234 16.97C115.214 16.9433 115.204 16.9133 115.204 16.88V10.12C115.204 10.0867 115.214 10.06 115.234 10.04C115.261 10.0133 115.291 10 115.324 10H116.244C116.277 10 116.304 10.0133 116.324 10.04C116.351 10.06 116.364 10.0867 116.364 10.12V16.88C116.364 16.9133 116.351 16.9433 116.324 16.97C116.304 16.99 116.277 17 116.244 17H115.324Z"
                                    fill="#70707F" />
                                <path
                                    d="M65.28 10.19C65.0733 10.19 64.9033 10.1233 64.77 9.99C64.6367 9.85667 64.57 9.68667 64.57 9.48C64.57 9.27333 64.6367 9.10333 64.77 8.97C64.9033 8.83667 65.0733 8.77 65.28 8.77C65.4867 8.77 65.6567 8.83667 65.79 8.97C65.9233 9.10333 65.99 9.27333 65.99 9.48C65.99 9.68667 65.9233 9.85667 65.79 9.99C65.6567 10.1233 65.4867 10.19 65.28 10.19ZM64.8 16C64.7667 16 64.7367 15.99 64.71 15.97C64.69 15.9433 64.68 15.9133 64.68 15.88V11C64.68 10.9667 64.69 10.94 64.71 10.92C64.7367 10.8933 64.7667 10.88 64.8 10.88H65.72C65.7533 10.88 65.78 10.8933 65.8 10.92C65.8267 10.94 65.84 10.9667 65.84 11V15.88C65.84 15.9133 65.8267 15.9433 65.8 15.97C65.78 15.99 65.7533 16 65.72 16H64.8ZM67.2888 16C67.2555 16 67.2255 15.99 67.1988 15.97C67.1788 15.9433 67.1688 15.9133 67.1688 15.88V9.12C67.1688 9.08667 67.1788 9.06 67.1988 9.04C67.2255 9.01333 67.2555 9 67.2888 9H68.2088C68.2422 9 68.2688 9.01333 68.2888 9.04C68.3155 9.06 68.3288 9.08667 68.3288 9.12V15.88C68.3288 15.9133 68.3155 15.9433 68.2888 15.97C68.2688 15.99 68.2422 16 68.2088 16H67.2888ZM70.2214 10.19C70.0147 10.19 69.8447 10.1233 69.7114 9.99C69.5781 9.85667 69.5114 9.68667 69.5114 9.48C69.5114 9.27333 69.5781 9.10333 69.7114 8.97C69.8447 8.83667 70.0147 8.77 70.2214 8.77C70.4281 8.77 70.5981 8.83667 70.7314 8.97C70.8647 9.10333 70.9314 9.27333 70.9314 9.48C70.9314 9.68667 70.8647 9.85667 70.7314 9.99C70.5981 10.1233 70.4281 10.19 70.2214 10.19ZM69.7414 16C69.7081 16 69.6781 15.99 69.6514 15.97C69.6314 15.9433 69.6214 15.9133 69.6214 15.88V11C69.6214 10.9667 69.6314 10.94 69.6514 10.92C69.6781 10.8933 69.7081 10.88 69.7414 10.88H70.6614C70.6947 10.88 70.7214 10.8933 70.7414 10.92C70.7681 10.94 70.7814 10.9667 70.7814 11V15.88C70.7814 15.9133 70.7681 15.9433 70.7414 15.97C70.7214 15.99 70.6947 16 70.6614 16H69.7414Z"
                                    fill="#2D2D3F" />
                            </svg>
                        </div>
                        <div class="inside-folder-uputa"> {{ $t('page_2.page_2_4.detail_1.txt') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="newFilePopTemplate" width="540px">
            <v-card id="dokument-template-catcher">
                <div class="upload-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                        <path
                            d="M13.8462 8.32601C13.8462 7.81949 13.4329 7.40888 12.9231 7.40888H5.53846C5.02866 7.40888 4.61538 7.81949 4.61538 8.32601C4.61538 8.83252 5.02866 9.24313 5.53846 9.24313H12.9231C13.4329 9.24313 13.8462 8.83252 13.8462 8.32601Z"
                            fill="#262639" />
                        <path
                            d="M12.6154 11.9945C12.6154 11.488 12.2021 11.0774 11.6923 11.0774H5.53846C5.02866 11.0774 4.61538 11.488 4.61538 11.9945C4.61538 12.501 5.02866 12.9116 5.53846 12.9116H11.6923C12.2021 12.9116 12.6154 12.501 12.6154 11.9945Z"
                            fill="#262639" />
                        <path
                            d="M12.9231 14.7459C13.4329 14.7459 13.8462 15.1565 13.8462 15.663C13.8462 16.1695 13.4329 16.5801 12.9231 16.5801H5.53846C5.02866 16.5801 4.61538 16.1695 4.61538 15.663C4.61538 15.1565 5.02866 14.7459 5.53846 14.7459H12.9231Z"
                            fill="#262639" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.61538 23H20.6154C22.4847 23 24 21.4944 24 19.6372V12.9116C24 12.4051 23.5867 11.9945 23.0769 11.9945H19.0769V2.4481C19.0769 0.707515 17.0967 -0.30495 15.6712 0.706742L15.4557 0.859637C14.4951 1.54136 13.1939 1.53907 12.2288 0.854147C10.6241 -0.284716 8.45285 -0.284716 6.84809 0.854147C5.88298 1.53907 4.58179 1.54136 3.62119 0.859638L3.40574 0.706742C1.98018 -0.30495 0 0.707515 0 2.4481V18.4144C0 20.9469 2.06638 23 4.61538 23ZM7.92114 2.34674C8.884 1.66342 10.1929 1.66342 11.1558 2.34674C12.7583 3.484 14.9218 3.49269 16.5288 2.35223L16.7442 2.19933C16.9479 2.0548 17.2308 2.19944 17.2308 2.4481V19.6372C17.2308 20.1876 17.3639 20.7071 17.5998 21.1658H4.61538C3.08598 21.1658 1.84615 19.9339 1.84615 18.4144V2.4481C1.84615 2.19944 2.12904 2.0548 2.33269 2.19933L2.54813 2.35223C4.15514 3.49269 6.31864 3.484 7.92114 2.34674ZM19.0769 19.6372V13.8288H22.1538V19.6372C22.1538 20.4814 21.4651 21.1658 20.6154 21.1658C19.7657 21.1658 19.0769 20.4814 19.0769 19.6372Z"
                            fill="#262639" />
                    </svg>
                    {{ $t('page_2.page_2_4.template_pop.title') }}
                </div>
                <div class="template-select-text-wrapper">
                    <v-select :items="template_documents_list" item-text="naziv" item-value="naziv"
                        v-model="template_file_name" :label="$t('page_2.page_2_4.template_pop.placeholder_1')"
                        class="template-select-drop"></v-select>
                    <v-text-field :label="$t('page_2.page_2_4.template_pop.placeholder_2')" v-model="new_docname"
                        class="template-text-drop"></v-text-field>
                    <div class="button-select-file-wrapper" v-if="is_permission_inside('template.create')"
                        @click="addTemplateFile()">
                        <div class="button-default button-create">
                            {{ $t('page_2.page_2_4.template_pop.btn_1') }}
                        </div>
                    </div>
                </div>
                <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
                    {{ $t('page_2.page_2_4.template_pop.err_msg') }}

                    <template v-slot:action="{ attrs }">
                        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                            {{$t("repetitive.okay")}}
                        </v-btn>
                    </template>
                </v-snackbar>


            </v-card>
        </v-dialog>
        <v-dialog v-model="newFolderPop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ $t('page_2.page_2_4.folder_pop.title') }}
                </div>
                <v-text-field class="universal-vdialog-textfield" label="Naziv foldera" v-model="newDirectoryName">
                </v-text-field>
                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="newFolderPop = false">
                        {{ $t("repetitive.cancel") }} </div>
                    <div class="universal-vdialog-button vbutton-primary" v-if="is_permission_inside('create')"
                        @click="createNewFolder()"> {{ $t('page_2.page_2_4.folder_pop.btn_2') }} </div>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="newFilePop" width="540" class="drop-document-ultra-wrapper">
            <v-card>
                <div class="upload-title" id="main-file-upload">{{ $t('page_2.page_2_4.upload_pop.title') }}</div>
                <div>
                    <!-- <input type="file" @change="onFileChange" /> -->
                    <div class="
                flex
                w-full
                h-screen
                items-center
                justify-center
                text-center
                drop-document-main-wrapper
              " id="app">
                        <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave"
                            @drop="drop">
                            <div class="loading-spinner"></div>
                            <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                                class="w-px h-px opacity-0 overflow-hidden absolute drag-drop" @change="onChange"
                                ref="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.csv, .xls, .xlsx, .svg,.txt" />

                            <label for="assetsFieldHandle" class="block cursor-pointer drop-document-area">
                                <div>
                                    <div class="select-file-message-wrapper">
                                        <div class="select-file-message">
                                            {{ $t('page_2.page_2_4.upload_pop.instruction') }}
                                        </div>
                                    </div>
                                    <div class="button-select-file-wrapper">
                                        <div class="button-default button-select-file">
                                            {{ $t('page_2.page_2_4.upload_pop.btn_1') }}
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <div class="opening-folder opening-radni-dokumenti section">
                                <div class="inside-radni-dokumenti">
                                    <draggable :class="filelist.length > 3 ? 'row-multiple' : 'row'" :sort="false">
                                        <div v-for="upFile in filelist" :key="upFile.id">
                                            <div :class="[
                                                filelist.length > 3
                                                    ? 'radni-dokument-inside-multiple'
                                                    : 'radni-dokument-inside',
                                                'preneseni-dokument',
                                            ]" draggable="true">
                                                <div :class="[
                                                    filelist.length > 3
                                                        ? 'document-image-wrapper-multiple'
                                                        : 'document-image-wrapper',
                                                ]">
                                                    <img class="preneseni-dokument-image"
                                                        :src="returnFileType(upFile.name)" />
                                                    <div v-show="filelist.length < 4" class="remove-document"
                                                        v-if="is_permission_inside('delete')"
                                                        @click="deleteFileInSpis(upFile)">
                                                        <span>X</span>
                                                    </div>
                                                </div>
                                                <div class="preneseni-dokument-title">
                                                    {{ upFile.name }}
                                                </div>

                                                <div v-show="filelist.length > 3" class="remove-document-multiple"
                                                    v-if="is_permission_inside('delete')"
                                                    @click="deleteFileInSpis(upFile)">
                                                    <span>X</span>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                            <div class="button-select-file-wrapper" v-if="is_permission_inside('create')">
                                <div class="button-default button-create" @click="!uploading ? addNewUploadFile() : ''">
                                    <svg v-if="uploading" class="update-event-spin" viewBox="0 0 50 50">
                                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8">
                                        </circle>
                                    </svg>
                                    <span v-else>{{ $t('page_2.page_2_4.upload_pop.btn_2') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
            <v-snackbar v-model="snackbar_upload" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
                {{ snackText }}
                <div v-for="(od, key) in odbacene" :key="key">{{ od.name }}</div>
                <template v-slot:action="{ attrs }">
                    <v-btn color="white" text v-bind="attrs" @click="snackbar_upload = false">
                        {{$t("repetitive.okay")}}
                    </v-btn>
                </template>
            </v-snackbar>
        </v-dialog>
        <v-dialog v-model="move_spis" width="540" class="odaberite-spis-wrapper">
            <v-card>
                <div id="preseli-main-upload" class="upload-title odaberite-spis-title">
                    {{ $t('page_2.page_2_4.spis_pop.title') }}</div>
                <div v-for="(sp, key) in all_files_rec" :key="key">
                    <tree-folders :depth="0" :item="sp" :accessToken="accessToken" @node-click="setUploadFolder"
                        :smjer="true"></tree-folders>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="deep-purple lighten-2" text @click="uploadFileToSpis()">
              {{move_btn}}
            </v-btn> -->
                    <div style="margin-top: 2.5rem;" class="button-preseli-wrapper">
                        <div class="button-default button-select-file" @click="uploadFileToSpis()">
                            {{ move_btn }}
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="renameFilePop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title" v-if="activityFile">
                    {{ $t('page_2.page_2_4.rename_pop_title') }}
                </div>
                <v-text-field class="universal-vdialog-textfield" label="$t('page_2.page_2_4.rename_pop.placeholder')"
                    v-model="new_file_name"></v-text-field>
                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="renameFilePop = false">
                        {{ $t("repetitive.cancel") }} </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="renameFile()">
                        {{ $t('page_2.page_2_4.rename_pop.btn_2') }} </div>
                </div>
                <v-snackbar v-model="snackbar_rename" :timeout="snackTimeout" color="snack-custom-dark-blue"
                    elevation="24">
                    {{ $t('page_2.page_2_4.rename_pop.err_msg') }}

                    <template v-slot:action="{ attrs }">
                        <v-btn color="white" text v-bind="attrs" @click="snackbar_rename = false">
                            {{$t("repetitive.okay")}}                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_screen" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ activityFile != null && activityFile.folder == undefined ? 'Jeste li sigurni da želite obrisati datoteku?' : 'Jeste li sigurni da želite obrisati folder?'}}
                </div>
                <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                    <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false">
                        {{ $t("repetitive.cancel") }} </div>
                    <div class="universal-vdialog-button vbutton-primary"
                        @click="activityFile.folder == undefined ? deleteFile(activityFile.id) : deleteFolder()">
                        {{ $t('page_2.page_2_4.delete_pop.btn_2') }} </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_screen_repeat" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ $t('page_2.page_2_4.delete_pop.err_msg') }}
                </div>
                <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                    <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen_repeat = false">
                        {{ $t("repetitive.cancel") }} </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="deleteFile(activityFile.id)">
                        {{ $t('page_2.page_2_4.delete_pop.btn_2') }} </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="file_locked_screen" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ $t('page_2.page_2_4.delete_pop.lock_msg') }}
                </div>
                <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                    <div class="universal-vdialog-button vbutton-primary" @click="file_locked_screen = false">
                        {{$t("repetitive.okay")}} </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="overlay_thumbnail" width="300">
            <DataLoader :is_on="pic_loading" />
            <div id="f-u-vuetify"></div>
            <img v-show="!pic_loading"
                :src="activityFile != null && activityFile.thumbnails.length > 0 ? activityFile.thumbnails[0].large.url : ''"
                @load="onImgLoad">
        </v-dialog>
        <v-snackbar v-model="snackbar_move" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
            {{ snackText }}
            <div v-for="(od, key) in odbacene" :key="key">{{ od }}</div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar_move = false">
                    {{$t("repetitive.okay")}}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
  
<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import auth from "@/services/auth";
import moment from "moment";
import $ from "jquery";
import gsap from "gsap";
import draggable from "vuedraggable";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import { getCaseData } from "@/router/case/handler"

import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import sharepoint from "../../../apiCallers/promise_handler_db/sharepoint";
import permissioner from "@/services/permissioner.js"
import graph from "@/services/graph.js";
import DataLoader from '@/components/generalComponents/DataLoader'
import { fileDownloadFinalization } from "../../../helpers/file/conversion";
import { switchGlobalLoaderMessage, switchGlobalLoaderState } from '../../../helpers/loader/global';
import { mergeDLPDFs } from "../../../helpers/file/merger";
import { shouldOpenInPreview } from "../../../helpers/file/index";


export default {

    components: {
        draggable,
        TreeFolders,
        CaseTab,
        DataLoader
    },
    props: ["group_url", "folder_id", "view_name", "permission_starter", "selected_spis", "movable", "pdf_merge_file_list", "all_files_rec", "spis_hover","group_type","duplicatable","no_empty","enable_preview_modal"],

    delimiters: ["${", "}"], // Avoid Twig conflicts
    data() {
        return {
            snackbar: false,
            snackbar_upload: false,
            snackbar_rename: false,
            snackTimeout: 10000,
            odbacene: [],
            accessToken: "",
            driveItem: {
                parentReference: {
                    id: "",
                },
                name: "",
            },
            pdf_mergeing: false,
            progressActive: false,

            template_file_name: "",
            newFilePopTemplate: false,
            new_docname: "",
            template_documents_list: [],

            draggedFile: "",
            filelist: [],
            loading: false,
            selectedFolder: null,
            activityFile: null,
            selectedFile: "",
            progress: 0,
            nazivDokumenta: "",
            folders: [],
            //Parrent refId ima funkciju da je uvijek trenutni direktorij na vrhu (njegov id)
            newDirectoryName: "",
            parrentRefId: "",
            radniRootId: "",
            radniDokumenti: [],
            nazivSpisFoldera: "",

            root_folder_id: "",
            currDirectory: [],

            breadCrumbs: [],
            newFolderPop: false,
            newFilePop: false,
            predmet_info: { broj_predmeta: '' },
            fiz_stranke: null,
            prav_protustranke: null,
            tmpBread: {
                id: "",
                nazivFoldera: "",
                idx: 0,
            },
            selected_folder_structure: [],
            spisi_structure: [],
            move_spis: false,
            selected_spis_dir: null,
            move_btn: this.$t('page_2.page_2_4.spis_pop.btn_1'),
            uploading: false,
            multi_file_list: [],
            isInitialLoad: true,
            currentButtonText: "Upload dokumenta",
            popupType: 0,
            delete_screen: false,

            new_file_name: "",
            renameFilePop: false,



            permission: {
                create: true,
                update: true,
                delete: true,
                read: true
            },

            mapped_case_permission: [],
            file_locked_screen: false,
            alert_text: '',
            snackText: '',
            delete_screen_repeat: false,
            overlay_thumbnail: false,
            pic_loading: true,
            snackbar_move: false,
        };
    },
    computed: {
        are_all_selected: function () {
            let number_cur_dir = this.currDirectory.filter((p) => {
                return p.folder == undefined;
            }).length;
            console.log(number_cur_dir);
            return number_cur_dir == this.multi_file_list.length;
        },
    },
    watch: {
        "spis_hover": function () {
            this.folderHoverSpis(this.spis_hover)
        },
        multi_file_list: function () {
            $(".radni-dokument-inside").removeClass("active");
            this.multi_file_list.forEach((p) => {
                let tmp_id = document.getElementById(p.name);
                $(tmp_id).addClass("active");
            });
        },
        move_spis: function () {
            if (this.move_spis == true) {
                this.selected_spis_dir = this.spisi_structure[0].item;
            }
            else {
                this.selected_spis_dir = null;
            }
        },
        overlay_thumbnail: {
            handler: function () {
                if (!this.overlay_thumbnail) {
                    this.pic_loading = true;
                }
            }
        }
    },
    async created() {
        this.accessToken = this.$store.state.aToken


        var init_file = await this.getRootSpisFile(this.folder_id);
        
        init_file.children = await this.get_recursive_data(this.folder_id);
       
        this.spisi_structure.push(init_file);


        this.isInitialLoad = true;
        this.getEverySpisNode();
        this.initRootFolder();

        //template documents for creating new files
        await sharepoint.getTemplateDocs().then((resp) => {
            this.template_documents_list = resp.data.order;
        });
        if (this.view_name == 'komunikacija') {
            this.$emit("loaded-docs", this.spisi_structure[0]);
        }
    },
    methods: {
        getFolderName(name) {
            switch (name.trim()) {
                case "Ulazni dokumenti":
                case "Ulazna pošta":
                    return this.$t('page_2.page_2_5.fold_1');
                case "Izlazni dokumenti":
                case "Izlazna pošta":
                    return this.$t('page_2.page_2_5.fold_2'); 
                case "Radni dokumenti":
                    return this.$t('page_2.page_2_4.fold_2'); 
                case "Popratni dokumenti":
                    return this.$t('page_2.page_2_4.fold_3');
                case "Naplata":
                    return this.$t('page_2.page_2_7.fold_1');
                    case "Računi":
                    return this.$t('page_2.page_2_7.fold_2');
                default:
                    return name;
            }
        },
        //SWITCH TO NEW VIEW BY ROUTE
        switchTab(nastavak) {
            this.$router.push("/case/" + this.group_url + "/" + nastavak);
        },
        //COLLECT ALL PDF-s and send them into mergeing process
        async spisToPDF() {
            if (this.pdf_merge_file_list.length == 0) {
                this.no_merge_snackbar = true;
            }
            else if (this.pdf_mergeing == false) {
                this.pdf_mergeing = true;
                await mergeDLPDFs(this.pdf_merge_file_list, this.selected_spis.ime).catch((error) => {
          alert(this.$t("components.general.error_merging"));
        }).finally(() => {
          this.pdf_mergeing = false;
        });
                
            }
        },
        onImgLoad() {
            this.pic_loading = false;
            setTimeout(() => {
                var getFuckingParent = document.getElementById("f-u-vuetify");
                $(getFuckingParent.parentElement).addClass('setDialogWidth');
            }, 10);
        },
        closeDetalji() {
            this.activityFile = null;
            this.multi_file_list = [];
        },
        setStyling() {
            this.active_pic = ''
            this.overlay_thumbnail = true;
            setTimeout(() => {
                var getFuckingParent = document.getElementById("f-u-vuetify");
                console.log($(getFuckingParent.parentElement))
                $(getFuckingParent.parentElement).addClass('setDialogWidth');
            }, 10);
        },
        is_permission_inside(wanted_permission, assistent_check = true) {
            // 0 = case
            // 1 = project
            if (this.group_type == 0)
                return permissioner.check_case_permsision(this.permission_starter + "." + wanted_permission, assistent_check)
            else if (this.group_type == 1)
                return permissioner.check_project_permission(this.permission_starter + "." + wanted_permission)
            else if (this.group_type == 2 && wanted_permission == "read")
                return true
            else
                return false
        },

        openRenamePop() {
            var full_old_name = this.activityFile.name.split(".");
            full_old_name.pop();
            this.new_file_name = full_old_name.join(".");
            this.renameFilePop = true;
        },
        openFolderRenamePop() {
            var full_old_name = this.activityFile.name;
            this.new_file_name = full_old_name;
            this.renameFilePop = true;
        },
        //Rename activity file
        renameFile() {
            var idx_ext = this.activityFile.name.split(".").length - 1;
            var extension = this.activityFile.name.split(".")[idx_ext];
            var new_name_ext = this.new_file_name;
            if (this.activityFile.folder == undefined) {
                new_name_ext = this.new_file_name + "." + extension;
            }

            if (this.new_file_name != '') {
                const driveItem = {
                    name: new_name_ext,
                };
                share.renameSingleDoc(this.accessToken, this.group_url, this.activityFile.id, driveItem).then(async (resp) => {
                    this.activityFile = null;
                    this.renameFilePop = false;
                    this.new_file_name = "";
                    this.currDirectory = await this.getAllDocsById(
                        this.breadCrumbs[this.breadCrumbs.length - 1].id
                    );
                    this.multi_file_list = [];
                }).catch(er => {
                    this.renameFilePop = false;
                    this.new_file_name = "";
                    this.file_locked_screen = true;
                });
            }
            else {
                this.snackbar_rename = true;
            }
        },
        async copyFile() {
            this.currDirectory = [];
            this.progressActive = true;
            const lastIndex = this.activityFile.name.lastIndexOf('.');
            let existing_number = 0
            let name_found = true;
            const before = this.activityFile.name.slice(0, lastIndex);
            const extension = this.activityFile.name.slice(lastIndex + 1);
            await graph.checkFolderContainsFile(this.group_url, this.activityFile.parentReference.id, before).then((resp) => {
                existing_number = resp.value.length;
            })

            while (name_found) {
                await graph.checkFolderContainsFile(this.group_url, this.activityFile.parentReference.id, `${before} (${existing_number}).${extension}`).then((resp) => {
                    if (resp.value.length == 0) {
                        name_found = false;
                    }
                    else {
                        existing_number += 1;
                    }
                })
            }

            const driveItem = {
                name: `${before} (${existing_number}).${extension}`,
            };
            share.copyFile(this.accessToken, this.group_url, this.activityFile.id, driveItem).then(async (resp) => {
                this.currDirectory = await this.getAllDocsById(
                    this.breadCrumbs[this.breadCrumbs.length - 1].id
                );
            });
        },
        async getRootSpisFile(sid) {
            let tmp_first = {
                item: {},
                children: [],
            };
            graph
                .getSingleFile(this.group_url, sid)
                .then(async (response) => {
                    tmp_first.item = response;
                });
            return tmp_first;
        },
        //GET INITIAL
        async get_recursive_data(id) {
            console.log();
            var ret_fold = [];
            this.accessToken = this.$store.state.aToken
            await graph
                .getFileChildren(this.group_url, id)
                .then((response) => {
                    console.log("got response from graph", response);
                    if (response.value.length > 0) {
                        response.value.forEach(async (dat) => {
                            let tmp_ret_item = {
                                item: dat,
                                children: [],
                            };
                            if (dat.folder != undefined) {
                                tmp_ret_item.children = await this.get_recursive_data(dat.id);
                            }
                            ret_fold.push(tmp_ret_item);
                        });
                    }
                });
            return ret_fold;
        },
        initRootFolder() {
            this.getRootDocuments();
        },
        folderHoverSpis(node) {
            if (node == null) {
                $("#" + this.driveItem.parentReference.id).removeClass("hovered-over")
                this.driveItem.parentReference.id = "";
                this.driveItem.name = "";
            } else {
                this.driveItem.parentReference.id = node.id_spis;
                $("#" + node.id_spis).addClass("hovered-over")
            }
        },
        async uploadFileToSpis() {
            this.multi_file_list = this.multi_file_list.filter((item) => item.folder == undefined)

            switchGlobalLoaderState(this.$t("components.file_management.sharepointUpload.uploading"))

                await fileDownloadFinalization(
                this.multi_file_list,
                this.$route.params.uid,
                this.selected_spis_dir
                )
                .then((resp) => {
                    console.log("Uploaded all documents response", resp);
                    if(resp.failed.length > 0){
                    alert(this.$t("components.file_management.sharepointUpload.error", { files: resp.failed.join(", ") }));
                    }
                })
                .finally(() => {
                    this.move_spis = false;
                    switchGlobalLoaderMessage(this.$t("components.file_management.sharepointUpload.success"));

                    setTimeout(() => {
                    this.multi_file_list = [];
                    switchGlobalLoaderState()
                    }, 2000);

                });
        },
        async uploadSingleSpisFile(counter, final_num) {
          
            // this.accessToken = this.$store.state.aToken
            // this.move_btn = this.$t('page_2.page_2_4.spis_pop.btn_2', { curDoc: parseInt(counter + 1), finalLeng: final_num });
            // var tmp_file = this.multi_file_list[counter];
            // let file_name_arr = tmp_file.name.split(".");
            // let file_ext = file_name_arr[file_name_arr.length - 1];

            // file_name_arr.pop();
            // let final_name = file_name_arr.join("");

            // let putanja = "";

            // let new_path = "";

            // if (
            //     file_ext == "jpg" ||
            //     file_ext == "jpeg" ||
            //     file_ext == "png" ||
            //     file_ext == "pdf"
            // ) {
            //     //logic for non pdf
            //     new_path = tmp_file["@microsoft.graph.downloadUrl"];
            // } else {
            //     putanja = tmp_file.parentReference.path.replace("/drive", "");

            //     new_path =
            //         "/drives/" +
            //         tmp_file.parentReference.driveId +
            //         putanja +
            //         "/" +
            //         encodeURIComponent(tmp_file.name);
            // }
            // let existing_number;
            // await graph.checkFolderContainsFile(this.group_url, this.selected_spis_dir.id, final_name).then((resp) => {
            //     existing_number = resp.value.length;
            // })
            // if (existing_number > 0) {
            //     final_name = final_name + ' (' + existing_number + ')';
            // }
            // await share
            //     .convertToPDF(
            //         this.accessToken,
            //         this.group_url,
            //         this.selected_spis_dir.id,
            //         new_path,
            //         final_name,
            //         file_ext,
            //         this.$store.state.logged_in_user.uid,
            //         this.selected_spis_dir.name
            //     )
            //     .finally(() => {
            //         if (counter + 1 >= final_num) {
            //             this.move_spis = false;
            //             this.multi_file_list = [];
            //             alert(
            //                 "Svi označeni dokumenti prebačeni su u odredište " +
            //                 this.selected_spis_dir.name
            //             );
            //             this.move_btn = this.$t('page_2.page_2_4.spis_pop.btn_1');

            //         } else {
            //             this.uploadSingleSpisFile(parseInt(counter + 1), final_num);
            //         }
            //     }).catch(() => {
            //         //this.uploadSingleSpisFile(counter,final_num);
            //         console.log("Neuspjelo dohvaćan je datoteke ", final_name)
            //     });
        },

        setUploadFolder(node) {
            this.selected_spis_dir = node;
        },
        getEverySpisNode() {
            for (var i = 0; i < this.selected_folder_structure.length; i++) {
                this.returnDriveItem(this.selected_folder_structure[i].id_spis, i);
            }
        },
        async returnDriveItem(sid, idx) {
            this.selected_folder_structure[idx]["item"] = null;
            graph
                .getSingleFile(this.group_url, sid)
                .then((response) => {
                    this.selected_folder_structure[idx]["item"] = response.data;
                });
            this.selected_folder_structure[idx]["nodes"] = await this.getAllDocsById(
                sid
            );
        },
        select_all() {
            this.multi_file_list = [];
            this.currDirectory.forEach((p) => {
                if (p.folder == undefined) {
                    this.multi_file_list.push(p);
                }
            });
        },
        async moveFile() {
            $('.radni-dokument-inside').removeClass('hovered');
            $('.clickable-breadcrumb').removeClass('hovered');
            if (this.driveItem.parentReference.id !== "" && this.is_permission_inside('create')) {
                //Start moveing
                await this.indexFileMove();
            } else {
                console.log("Ništa od slanja datoteke.");
            }
        },
        indexFileMove() {
            this.odbacene = [];
            this.snackbar_move = false;
            let path = "/drive/items/" + this.multi_file_list[this.multi_file_list.length - 1].id;
            this.driveItem.name = this.multi_file_list[this.multi_file_list.length - 1].name,
                share
                    .moveDriveItem(
                        this.accessToken,
                        this.group_url,
                        this.breadCrumbs[this.breadCrumbs.length - 1].id,
                        path,
                        this.driveItem
                    )
                    .then(() => {
                    })
                    .catch((err) => {
                        if (err.response.status == 409) {
                            this.odbacene.push(this.driveItem.name);
                            this.snackText =
                                "Sljedeće datoteke nisu prenesene jer u odredišnom folderu postoji datoteka sa istim nazivom:";
                            this.snackbar_move = true;
                        }
                        else console.log(err)
                    })
                    .finally(() => {
                        this.multi_file_list.pop()
                        if (this.multi_file_list.length > 0) {
                            this.indexFileMove()
                        }
                        else {
                            this.multi_file_list = [];
                            setTimeout(async () => {
                                this.currDirectory = await this.getAllDocsById(
                                    this.breadCrumbs[this.breadCrumbs.length - 1].id
                                );
                            }, 200);
                        }
                    })
        },
        emptyDestDrag() {
            $('.radni-dokument-inside').removeClass('hovered');
            $('.clickable-breadcrumb').removeClass('hovered');
            this.driveItem = {
                parentReference: {
                    id: "",
                },
                name: "",
            };
        },


        overFolder(fileId, e) {
            $(e.target).closest('.radni-dokument-inside').addClass('hovered');
            $(e.target).closest('.clickable-breadcrumb').addClass('hovered');
            this.driveItem = {
                parentReference: {
                    id: fileId,
                },
                name: this.draggedFile.name,
            };
        },
        startDragMove(file) {
            this.draggedFile = file;
            let tmp_index = this.multi_file_list.findIndex((p) => {
                return p.id == file.id;
            });
            if (tmp_index == -1) {
                this.multi_file_list.push(file);
            }
        },
        onChange() {
            this.snackbar_upload = false;
            this.odbacene = [];
            let tmp_file_list = [...this.$refs.file.files];
            let filt_tmp_file_list = tmp_file_list.filter((file) => file.size < 57671680);
            const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
            if (num_odbacenih != 0) {
                this.snackbar_upload = true;
                this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
                this.snackText =
                    "Zbog ograničenja Sharepoint-a odbačene su sljedeće datoteke veće od 55MB:";
            }
            this.filelist = this.filelist.concat(filt_tmp_file_list);
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
                gsap.to(".loading-spinner", 0, { display: "block" });
                gsap.to(".loading-spinner", 0.5, { opacity: 1 });
                gsap.to(".drop-document-area", 0.5, {
                    filter: "blur(3px)",
                    opacity: 0.7,
                });
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
            gsap.to(".loading-spinner", 0.5, { opacity: 0 });
            gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
            //
            gsap.to(".loading-spinner", 0.5, { opacity: 0 });
            gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
        },
        switchDate(inData) {
            return moment(inData.toString()).format("lll");
        },
        goToPredmet(nastavak) {
            if (nastavak === "") {
                this.$router.push("/case/" + this.group_url + "/");
            } else this.$router.push(nastavak);
        },
        setFileForActivity(fileRef) {
            console.log("Single file selection");
            this.multi_file_list = [];
            this.multi_file_list.push(fileRef);
            this.activityFile = fileRef;
            //anim detalja spisa
            gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
        },
        setMultiFileSelection(fileRef) {
            console.log("Multi file selection");

            let tmp_index = this.multi_file_list.findIndex((p) => {
                return p.id == fileRef.id;
            });

            if (tmp_index == -1) {
                this.multi_file_list.push(fileRef);
            } else {
                this.multi_file_list.splice(tmp_index, 1);
            }

            // if($(el).hasClass("active"))
            // {
            //   console.log("Duplo kliknuto")

            // }else{
            //   this.multi_file_list.push(fileRef);
            //    $(el).addClass("active");
            // }
            this.activityFile = null;

            //anim detalja spisa

            gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
        },

        returnFileType(file_name) {
            var idx_ext = file_name.split(".").length - 1;
            var extension = file_name.split(".")[idx_ext].toLowerCase();

            var return_val = require("@/assets/img/doc_icon.svg");
            switch (extension) {
                case "docx":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "dotx":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "dotm":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "pptx":
                    return_val = require("@/assets/img/ppt-icon.png");
                    break;
                case "ppt":
                    return_val = require("@/assets/img/ppt-icon.png");
                    break;
                case "doc":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "pdf":
                    return_val = require("@/assets/img/pdf_icon.svg");
                    break;
                case "csv":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "xlsx":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "jpg":
                    return_val = require("@/assets/img/jpg_icon.svg");
                    break;
                case "jpeg":
                    return_val = require("@/assets/img/jpg_icon.svg");
                    break;
                case "png":
                    return_val = require("@/assets/img/png_icon.svg");
                    break;
                case "folder":
                    return_val = require("@/assets/img/folder_yellow.svg");
                    break;
                default:
                    return_val = require("@/assets/img/dat_icon.svg");
                    break;
            }
            return return_val;
        },
        goStepBack() {
            this.folders = [];
            this.parrentRefId = this.parrentRefId.pop();
            this.goDown(this.parrentRefId[parrentRefId.length - 1]);
        },
        // DELETE ALL FILES IN SPIS
        deleteFileInSpis(file) {
            this.filelist = this.filelist.filter((f) => f != file);
        },

        handleFileOpen(file) {
            if (this.enable_preview_modal && shouldOpenInPreview(file)) {
                this.$emit("preview-file", file);
            } else {
                this.openFile(file);
            }
        },
        openFile(file) {
            var idx_ext = file.name.split(".").length - 1;
            var extension = file.name.split(".")[idx_ext];
            var ret_url = file.webUrl;
            // window.open(file.webUrl);
            // console.log(file.webUrl)
            switch (extension) {
                case "docx":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-word:ofe|u|" + ret_url);
                    break;
                case "dotm":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-word:ofe|u|" + ret_url);
                    break;
                case "dotx":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-word:ofe|u|" + ret_url);
                    break;
                case "doc":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-word:ofe|u|" + ret_url);
                    break;
                case "csv":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-word:ofe|u|" + ret_url);
                    break;
                case "xlsx":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-excel:ofe|u|" + ret_url);
                    break;
                case "ppt":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-powerpoint:ofe|u|" + ret_url);
                    break;
                case "pptx":
                    ret_url = this.getDownloadUrl(file);
                    window.open("ms-powerpoint:ofe|u|" + ret_url);
                    break;
                default:
                    window.open(file.webUrl);
                    break;
            }

            // if(file.name.includes(".docx") || file.name.includes("doc"))
            // {
            //window.open("ms-word:ofe|u|"+sharepoint_part);
            // }else{
            //   window.open(file.webUrl);
            // }
        },
        getDownloadUrl(file) {
            let separator = "_layouts/15";
            var sharepoint_part =
                file.webUrl.split(separator)[0] + process.env.VUE_APP_SHAREPOINT_OPEN_FILE;
            for (var i = 0; i < this.breadCrumbs.length; i++) {
                sharepoint_part +=
                    encodeURIComponent(this.breadCrumbs[i].nazivFoldera) + "/";
            }
            sharepoint_part += encodeURIComponent(file.name);

            return sharepoint_part;
        },
        deleteFolder() {
            if (this.activityFile.folder.childCount > 0) {
                this.delete_screen = false;
                this.delete_screen_repeat = true;
            }
            else {
                this.deleteFile(this.activityFile.id);
            }
        },
        deleteFile(fileId) {
            this.currDirectory = [];
            this.progressActive = true;
            var path = "/drive/items/" + fileId;
            share
                .deleteFile(this.accessToken, this.group_url, path)
                .then(() => {
                    // this.goDown(this.selectedFolder);
                    setTimeout(async () => {
                        this.currDirectory = await this.getAllDocsById(
                            this.breadCrumbs[this.breadCrumbs.length - 1].id
                        );
                    }, 200);
                    this.activityFile = null;
                    this.delete_screen = false;
                    this.delete_screen_repeat = false
                    this.multi_file_list = [];
                }).catch(er => {
                    this.delete_screen = false;
                    this.delete_screen_repeat = false
                    this.file_locked_screen = true;
                });
        },
       

        onFileChange(e) {
            const selectedFile = e.target.files[0];
            this.selectedFile = selectedFile;
            console.log(this.selectedFile);
        },

        previewFiles() {
            var input = document.getElementById("myFiles");
            var file = input.files[0];
            console.log(file);
            share.addDocumentInSpis(
                this.accessToken,
                this.group_url,
                this.selectedFolder,
                file
            );
        },
        openUploadFolder() {
            this.$emit('uploadStyling')
        },
        preseliStyling() {
            this.move_spis = true;
            setTimeout(function () {
                var upl = document.getElementById("preseli-main-upload");
                $(upl.parentElement.parentElement).addClass("file-upload-dialog-wrapper");
                $(upl.parentElement).addClass("main-file-upload-wrapper");
                $('.spis-megawrapper').removeClass('active');
                $('.main-file-upload-wrapper').find('.spis-megawrapper:first').click();
            }, 100);
        },
        templateStyling() {
            this.newFilePopTemplate = true;
            setTimeout(function () {
                var upl = document.getElementById("dokument-template-catcher");
                $(upl.parentElement).addClass("dokument-template-vdialog");
            }, 100);
        },
        async addNewUploadFile() {
            // console.log(fl);
            this.uploading = true;
            if (this.filelist.length != 0) {
                const formData = new FormData();
                this.filelist.forEach((fl) => {
                    formData.append("files", fl);
                });

                if (!window.location.href.includes('archived-case')) {
                    formData.append("token", this.accessToken);
                }
                formData.append("groupId", this.group_url);
                formData.append(
                    "sid",
                    this.breadCrumbs[this.breadCrumbs.length - 1].id
                );
                // formData.append("name", esc_filename);
                // appending file

                share.addDocumentInSpis(formData).then(() => {
                    this.filelist = [];
                    this.uploading = false;
                    this.newFilePop = false;
                    document.getElementById("assetsFieldHandle").value = "";
                    setTimeout(async () => {
                        this.currDirectory = await this.getAllDocsById(
                            this.breadCrumbs[this.breadCrumbs.length - 1].id
                        );
                    }, 200);
                });
            } else {
                this.uploading = false;
            }

        },
        createNewFolder() {
            if (this.newDirectoryName != "") {
                this.createFoldToParrent(
                    this.breadCrumbs[this.breadCrumbs.length - 1].id,
                    this.newDirectoryName
                );
            } else {
                //baci error
            }
        },

        async addTemplateFile() {
            if (this.template_file_name != "") {
                let split_name = this.template_file_name.split(".");
                let ext_name = split_name[split_name.length - 1];
                if (this.new_docname != "") {
                    await share
                        .templateFileInit(
                            this.accessToken,
                            this.group_url,
                            this.breadCrumbs[this.breadCrumbs.length - 1].id,
                            this.template_file_name,
                            this.new_docname + '.' + ext_name,
                        )
                        .then(async (resp) => {
                            this.newFilePopTemplate = false;
                            this.new_docname = '';
                            this.currDirectory = await this.getAllDocsById(
                                this.breadCrumbs[this.breadCrumbs.length - 1].id
                            );
                        });
                }
                else {
                    this.snackbar = true;
                }
            }
            else {
                this.snackbar = true;
            }
        },

        createFoldToParrent(parrentId, docname) {
            share
                .createFolderDocs(
                    this.accessToken,
                    this.group_url,
                    parrentId,
                    docname
                )
                .then(async () => {
                    this.newFolderPop = false;
                    this.newDirectoryName = "";
                    this.currDirectory = await this.getAllDocsById(
                        this.breadCrumbs[this.breadCrumbs.length - 1].id
                    );
                });
            // .then(() => {
            //   this.goDown(this.selectedFolder);
            //   this.nazivDokumenta = "";
            // });
        },
        breadcrumbsViewPushback(indexCut) {
            this.activityFile = null;
            this.multi_file_list = [];
            if (this.breadCrumbs.length > 1) {
                this.breadCrumbs = this.breadCrumbs.slice(0, indexCut + 1);
                setTimeout(async () => {
                    this.currDirectory = [];
                    this.currDirectory = await this.getAllDocsById(
                        this.breadCrumbs[this.breadCrumbs.length - 1].id
                    );
                }, 200);
            }
        },
        async setNewFileView(foldRef) {
            //primi foldera čiju ćemo djecu pregledati
            //Nakon toga napravi poziv i osvježi koje su datoteke unutra
            this.activityFile = null;
            this.multi_file_list = [];
            var duljina = this.breadCrumbs.length;
            this.breadCrumbs.push({
                id: foldRef.id,
                nazivFoldera: foldRef.name,
                idx: duljina,
            });
            this.currDirectory = [];
            this.currDirectory = await this.getAllDocsById(foldRef.id);
            if(this.no_empty === true)
        {
            this.currDirectory = this.currDirectory.filter((p)=>p.item.folder.childCount > 0)
        }
        },

        async getAllDocsById(sid) {
            this.progressActive = true;
            var all_files = [];
            await graph
                .getFileChildren(this.group_url, sid)
                .then((response) => {
                    response.value.forEach((dat) => {
                        all_files.push(dat);
                    });
                    this.progressActive = false;
                })
                .catch((err) => (this.progressActive = false));

            return all_files;
        },
        async getRootDocuments() {
            await graph
                .getSingleFile(this.group_url, this.folder_id)
                .then(async (response) => {
                    this.setNewFileView(response);
                    this.isInitialLoad = false;
                });
            // share
            //     .getRootDocs(this.accessToken, this.group_url)
            //     .then((response) => {
            //         console.log(response.data);
            //         response.data.files.value.forEach((doc) => {
            //             if (doc.id == this.folder_id) {
            //                 this.setNewFileView(doc);
            //             }
            //         });
            //         this.isInitialLoad = false;
            //     });
        },
    },
    mounted() {
        setTimeout(() => {
            gsap.to(".spisi-right", 0.3, { marginTop: "-30rem" });
            const cb = document.getElementById("chb");
            const bt = document.getElementById("button-text");
            // cb.onmouseenter = function () {
            //     bt.innerHTML = "Kreiraj iz predloška";
            //     gsap.fromTo(bt, 0.5, { opacity: 0, x: -10 }, { x: 0, opacity: 1 });
            //     gsap.to(".upload-icon path:nth-of-type(2)", 0.2, { scale: 0 });
            //     gsap.to(".upload-icon path:nth-of-type(1)", 0.2, {
            //         rotate: 90,
            //         transformOrigin: "center",
            //         y: 3,
            //         scale: 1.2
            //     });
            // };
            // cb.onmouseleave = function () {
            //     bt.innerHTML = "Upload dokumenata";
            //     gsap.fromTo(bt, 0.5, { opacity: 0, x: 10 }, { x: 0, opacity: 1 });
            //     gsap.to(".upload-icon path:nth-of-type(2)", 0.2, { scale: 1 });
            //     gsap.to(".upload-icon path:nth-of-type(1)", 0.2, {
            //         rotate: 0,
            //         y: 0,
            //         scale: 1
            //     });
            // };
        }, 1500);
    },
};
</script>
  
<style>
.drag-drop {
    visibility: hidden;
}
</style>